import axios from '@/helpers/axios';
import newMockData from '../../../__mocks__/transactionHistoryNewMock.json';
import { orderApi, profileApi, custServiceApi, paymentApi, deliveryApi, numberPortApi } from '@/helpers/apis';
import { getPayloadParams } from '@/helpers/common';

export const getProfile = (brn, email) => {
  const url = profileApi.PROFILE_GETPROFILE;
  return axios.post(url, { brn, email });
};

export const getProfileWithoutDoc = (brn, email) => {
  const url = profileApi.PROFILE_GETPROFILEWITHOUTDOC;
  return axios.post(url, { brn, email });
};

export const updateProfile = (profile) => {
  const url = profileApi.PROFILE_UPDATEPROFILE;
  return axios.post(url, profile);
};

export const uploadDocuments = (documentsData) => {
  const url = profileApi.DOCUMENT_UPLOAD_DOCUMENT_MULTIPART;
  return axios.post(url, documentsData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const deleteDocument = (documentId) => {
  const url = `${profileApi.DOCUMENT_DELETE_DOCUMENT}/${documentId}`;
  return axios.get(url);
};

export const downloadDocument = (documentId) => {
  const url = `${profileApi.DOCUMENT_DOWNLOAD_DOCUMENT_MULTIPART}/${documentId}`;
  return axios.get(url, { responseType: 'blob' });
};

export const getAccountPage = (reqPayload) => {
  const url = profileApi.FETCHACCOUNT;
  return axios.post(url, reqPayload);
};

export const getPolicyTemplate = (reqPayload) => {
  const url = profileApi.GET_POLICY_TEMPLATE;
  return axios.post(url, reqPayload);
};

export const getPolicyList = (reqPayload) => {
  const url = profileApi.GET_POLICY_LIST;
  return axios.post(url, reqPayload);
};

export const getPolicyDetails = (reqPayload) => {
  const url = profileApi.GET_POLICY_DETAILS;
  return axios.post(url, reqPayload);
};

export const updatePolicy = (reqPayload) => {
  const url = profileApi.UPDATE_POLICY;
  return axios.post(url, reqPayload);
};

export const deletePolicy = (reqPayload) => {
  const url = profileApi.DELETE_POLICY;
  return axios.post(url, reqPayload);
};

export const getTabConfigType = () => {
  const url = profileApi.APPCONGIG_GET_TAB_CONFIG_TYPE;
  return axios.get(url);
};

export const getAllOrderTranHistory = (payload) => {
  const params = getPayloadParams(payload);
  const url = `${orderApi.GET_ALL_ORDER_HISTORY}?${params}`;
  return axios.get(url);
};

export const getTransactionHistoryDetail = (ordNo, brn, email) => {
  const payload = { orderId: ordNo, brn: brn, emailId: email };
  const url = orderApi.GET_TRANSACTION_HISTORY_DETAIL;
  return axios.post(url, payload);
};

export const getApprovalStatusTranHistory = (_payload) => {
  return Promise.resolve(newMockData);
};

export const updateTransCancelStatus = (_orderNo: string) => {
  return Promise.resolve('success');
};

export const updateDeliveryDetail = (_reqData) => {
  return Promise.resolve('success');
};

export const getAllChangeUserDetails = (brn, page, size, searchRequest) => {
  const queryObj = { brn, page, size, searchRequest };
  const params = getPayloadParams(queryObj);
  const url = `${custServiceApi.CHANGE_USER__ALLDETAILS}?${params}`;
  return axios.get(url);
};

export const addNewUser = (_user) => {
  return Promise.resolve('success');
};

export const updateChangeUser = (user) => {
  const url = custServiceApi.CHANGE_USER_UPDATE;
  return axios.post(url, user);
};

export const getDeliveryAddressesList = (payload) => {
  const url = deliveryApi.GET_DELIVERY_ADDRESS_LIST_BY_BRN;
  return axios.post(url, payload);
};

export const getResidentialAddressesList = (payload) => {
  const url = deliveryApi.PDPA_RETRIEVE_RES_ADDRESS;
  return axios.post(url, payload);
};

export const saveDeliveryAddressesList = (payload) => {
  const url = deliveryApi.PDPA_SAVE_NEW_RES_ADDRESS;
  return axios.post(url, payload);
};
export const editDeliveryAddressesList = (payload) => {
  const url = deliveryApi.PDPA_UPDATE_EXIST_ADDRESS;
  return axios.put(url, payload);
};

export const deleteDeliveryAddresses = (payload) => {
  const url = deliveryApi.PDPA_DELETE_EXIST_ADDRESS;
  return axios.put(url, payload);
};

export const getBillingAccountsList = (brn, page, size, searchParam) => {
  const url = `${paymentApi.FETCH_BILLING_ACCOUNTS_LIST_BY_BRN}?page=${page.toString()}&size=${size.toString()}`;
  const payload = { brn: brn, searchParam: searchParam };
  return axios.post(url, payload);
};

export const getBillingAccountEnrollmentStatus = (payload) => {
  const url = paymentApi.FETCH_ENROLLMENT_STATUS;
  return axios.post(url, payload);
};

export const getBillingAccountNumber = (payload) => {
  const url = paymentApi.FETCH_BILLING_SERVICE_NUMBERS;
  return axios.post(url, payload);
};
export const updateCreditCardDetail = (payload) => {
  const url = paymentApi.FETCH_CREDIT_CARD_DETAIL;
  return axios.post(url, payload);
};

export const changeBillingAddress = (payload) => {
  const url = profileApi.CHANGE_BILLING_ADDRESS;
  return axios.post(url, payload);
};

export const uploadNumberPortDocuments = (documentsData) => {
  const url = numberPortApi.DOCUMENT_UPLOAD_NUMBER_PORT_DOCUMENT;
  return axios.post(url, documentsData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const downloadDocumentNumberPort = (documentId) => {
  const url = `${numberPortApi.DOCUMENT_DOWNLOAD_DOCUMENT}/${documentId}`;
  return axios.get(url, { responseType: 'blob' });
};

export const deleteDocumentNumberPort = (documentId) => {
  const url = `${numberPortApi.DOCUMENT_DELETE_DOCUMENT}/${documentId}`;
  return axios.post(url);
};
